import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

/**
 * rotate
 */
export class Rotate extends Component {
    static TypeName = 'rotate';

    /* Properties that are configurable in the editor */

    @property.float(200)
    speed!: number;

    update(dt: number) {
        this.object.rotateAxisAngleDegObject([0, 0, 1], dt * this.speed);
    }
}
